import React from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import UnderConstructionLandingPage from "../UnderConstruction";

function CreditsPage({ userRole = "candidate" }) {
  return (
    <>
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="credits" userRole={userRole} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="credits"
            userRole={userRole}
            newTitle="Buy Credits"
            noNavigate={true}
          />
          <UnderConstructionLandingPage />
        </div>
      </div>
    </>
  );
}

export default CreditsPage;
